module.exports = __webpack_public_path__ + "static/image/login_logo.1d119dd990992a022b87b45e12ca1485.png";